export enum LeaderboardStatusType {
  INITIAL,
  ACTIVE,
  INACTIVE,
  ERROR,
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/leaderboard-status-type.ts